import { render, staticRenderFns } from "./CustomerComments.vue?vue&type=template&id=30b7a428"
import script from "./CustomerComments.vue?vue&type=script&lang=js"
export * from "./CustomerComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports